export const getDomain = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' ? 'localhost' : `.${hostname.split('.').slice(-2).join('.')}`;
};

export const setToken = (cookieName, cookieValue) => localStorage.setItem(cookieName, cookieValue);

export const setCookie = (cookieName, cookieValue, expiryInDays, path = '/') => {
  const d = new Date();
  d.setTime(d.getTime() + expiryInDays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  const domain = getDomain();

  const cookieString = `${cookieName}=${cookieValue};${expires};path=${path};domain=${domain}`;
  document.cookie = cookieString;
};

export const getToken = (tokenName) => localStorage.getItem(tokenName) || '';

export const getCookie = (cookieName) => {
  const name = `${cookieName}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const removeCookie = (cookieName, path, domain) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    if (cookieName) {
      if (name === cookieName) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path ? path : ''};domain=${domain ? domain : ''}`;
        return;
      }
    } else {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path ? path : ''};domain=${domain ? domain : ''}`;
    }
  }
};

export const deleteLocalStorage = (name) => {
  if (name) {
    localStorage.removeItem(name);
  } else {
    localStorage.clear();
  }
};
